import { AI_ACTIONS } from '../../actions/ai';

const initialState = {
  promptId: undefined,
  conversationId: undefined,
  conversation: []
};

const AIReducer = (state = initialState, action) => {
  switch (action.type) {
    case AI_ACTIONS.CONVERSATION_STARTED: {
      return {
        ...state,
        ...action.payload,
        conversation: []
      };
    }
    case AI_ACTIONS.CONVERSATION_UPDATED: {
      return {
        ...state,
        conversation: action.payload.messages
      };
    }
    case AI_ACTIONS.CONVERSATION_ENDED: {
      return { ...initialState };
    }
    default:
      return state;
  }
};

export default AIReducer;
